module.exports = __webpack_public_path__ + "img/16-women-and-climate.0b424984.jpg";